import { ArrowForwardIos, Check } from "@material-ui/icons";
import React, { Dispatch, memo, SetStateAction, useEffect, useState } from "react";
import PuiTypography from "../../../components/elements/PuiTypography";
import stylesPc from "./TimelineBar.module.css";
import stylesSp from "./TimelineBar_SP.module.css";
import { useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import { Bitrate, Resolution, FrameRate } from "../../models/video";
import { t } from "i18next";
import { IsDevice } from "../../../components/function/useDeviceFlag";

interface CustomTimelineSettingProps {
    selectResolution: (resolution: string) => void;
    selectvideoFrameRate: (framerate: string) => void;
    selectBitRate: (bitrate: string) => void;
    openVideoResolutionSelect: boolean;
    setOpenVideoResolutionSelect: Dispatch<SetStateAction<boolean>>;
    openVideoFramerateSelect: boolean;
    setOpenVideoFramerateSelect: Dispatch<SetStateAction<boolean>>;
    openVideoBitrateSelect: boolean;
    setOpenVideoBitrateSelect: Dispatch<SetStateAction<boolean>>;
}
function CustomTimelineSetting({
    selectResolution,
    selectvideoFrameRate,
    selectBitRate,
    openVideoResolutionSelect,
    setOpenVideoResolutionSelect,
    openVideoFramerateSelect,
    setOpenVideoFramerateSelect,
    openVideoBitrateSelect,
    setOpenVideoBitrateSelect,
}: CustomTimelineSettingProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("iphone") ? stylesSp : stylesPc;

    const { videoBitrate, videoFrameRate, videoResolutionWidth, videoResolutionHeight } =
        useSelector((state: AppState) => ({
            videoBitrate: state.videoInfo.exportVideoInfo.bitrate,
            videoFrameRate: state.videoInfo.exportVideoInfo.framerate,
            videoResolutionWidth: state.videoInfo.exportVideoInfo.width,
            videoResolutionHeight: state.videoInfo.exportVideoInfo.height,
        }));
    // 数字のところ要確認
    // const bitrateArray = ["300000", "1000000", "2000000"];
    const currentResolution = `${videoResolutionWidth}x${videoResolutionHeight}`;
    const [videoResolution, setVideoResolution] = useState(currentResolution);

    useEffect(() => {
        const currentResolutionDami = `${videoResolutionWidth}×${videoResolutionHeight}`;
        console.log(currentResolutionDami);
        setVideoResolution(currentResolutionDami);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoResolutionWidth]);

    return (
        <div className={styles.customArea}>
            {/* 解像度 */}
            <div className={styles.customResolutionArea}>
                <div
                    onClick={() => {
                        setOpenVideoResolutionSelect(!openVideoResolutionSelect);
                        setOpenVideoBitrateSelect(false);
                        setOpenVideoFramerateSelect(false);
                    }}
                    className={styles.customDescription}
                >
                    <div className={styles.customTitle}>
                        <PuiTypography size={16}>{t("解像度")}</PuiTypography>
                    </div>
                    <div className={styles.customName}>
                        <PuiTypography size={16}>{videoResolution}</PuiTypography>
                    </div>
                    <div className={styles.customDescriptionIcon}>
                        <ArrowForwardIos />
                    </div>
                </div>
                {openVideoResolutionSelect && (
                    <div className={styles.customSelect}>
                        {Resolution.map((resolution, index) => (
                            <div
                                style={{
                                    borderBottom:
                                        index !== 2 ? "1px solid rgba(255,255,255,0.05)" : "none",
                                }}
                                key={index}
                                onClick={() => selectResolution(resolution)}
                            >
                                <PuiTypography size={16}>{resolution}</PuiTypography>
                                {videoResolution === resolution && (
                                    <Check className={styles.checkIcon} />
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {/* フレームレート */}
            <div className={styles.customFrameRateArea}>
                <div
                    onClick={() => {
                        setOpenVideoFramerateSelect(!openVideoFramerateSelect);
                        setOpenVideoBitrateSelect(false);
                        setOpenVideoResolutionSelect(false);
                    }}
                    className={styles.customDescription}
                >
                    <div className={styles.customTitle}>
                        <PuiTypography size={16}>{t("フレームレート")}</PuiTypography>
                    </div>
                    <div className={styles.customName}>
                        <PuiTypography size={16}>{videoFrameRate}fps</PuiTypography>
                    </div>
                    <div className={styles.customDescriptionIcon}>
                        <ArrowForwardIos />
                    </div>
                </div>
                {openVideoFramerateSelect && (
                    <div className={styles.customSelect}>
                        {Array.from(new Set(FrameRate)).map((framerate, index) => (
                            <div
                                style={{
                                    borderBottom:
                                        index !== 1 ? "1px solid rgba(255,255,255,0.05)" : "none",
                                }}
                                key={index}
                                onClick={() => selectvideoFrameRate(framerate)}
                            >
                                <PuiTypography size={16}>{framerate}fps</PuiTypography>
                                {videoFrameRate === Number(framerate) && (
                                    <Check className={styles.checkIcon} />
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {/* ビットレート */}
            <div className={styles.customBitrateArea}>
                <div
                    onClick={() => {
                        setOpenVideoBitrateSelect(!openVideoBitrateSelect);
                        setOpenVideoFramerateSelect(false);
                        setOpenVideoResolutionSelect(false);
                    }}
                    className={styles.customDescription}
                >
                    <div className={styles.customTitle}>
                        <PuiTypography size={16}>{t("ビットレート")}</PuiTypography>
                    </div>
                    <div className={styles.customName}>
                        <PuiTypography size={16}>{Number(videoBitrate) / 1000}k</PuiTypography>
                    </div>
                    <div className={styles.customDescriptionIcon}>
                        <ArrowForwardIos />
                    </div>
                </div>
                {openVideoBitrateSelect && (
                    <div className={styles.customSelect}>
                        {Bitrate.map((bitrate, index) => (
                            <div
                                style={{
                                    borderBottom:
                                        index !== 2 ? "1px solid rgba(255,255,255,0.05)" : "none",
                                }}
                                key={index}
                                onClick={() => selectBitRate(bitrate)}
                            >
                                <PuiTypography size={16}>{Number(bitrate) / 1000}k</PuiTypography>
                                {videoBitrate === Number(bitrate) && (
                                    <Check className={styles.checkIcon} />
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {/* ノイズ除去 */}
            {/* <li className={styles.columnStyle}>
        <div className={styles.formHelperText}>ノイズ除去</div>
        <div className={styles.form}>
            <Select
                color="secondary"
                id="selectNoise"
                variant="outlined"
                defaultValue="false"
                value={String(noiseValue)}
                onChange={selectNoise}
                className={classes.select}
            >
                <MenuItem value={"false"}>false</MenuItem>
                <MenuItem value={"true"}>true</MenuItem>
            </Select>
        </div>
    </li> */}
        </div>
    );
}
export default memo(CustomTimelineSetting);
